  export const articleTypes = [
    'Conference Abstract',
    'Original Article',
    'Review',
    'Systematic review',
    'Perspective paper',
    'Protocol',
    'Editorial',
    'Commentary',
    'Letter to the Editor',
    'Field story',
    'Opinion paper',
    'Learning Corner',
    'ASFIRJ THESES',
    'Career Corner',
    'Special Issue'
  ];

  export const publicArticleTypes = [
    'Review',
    'Original Article',
    'Narrative Review',
    'Systematic Review',
    'Letter to Editor',
    'Editorial',
    'Commentary',
    'Protocol',
    'Perspectives',
    'Data',
    'Opinion',
    'Learning Corner',
    'Field Story',
    'Insight',
    'Correspondence'
  ];


export   const disciplines = [
    'Agricultural sciences',
    'Allied Health Sciences',
    'Anthropology',
    'Arts',
    'Biology',
    'Chemistry',
    'Climate Change',
    'Computer and Information Sciences',
    'Earth Sciences',
    'Engineering and Technology',
    'Environmental Sciences',
    'Epidemiology',
    'Humanities',
    'Leadership and Management',
    'Life Sciences',
    'Materials Science',
    'Mathematics',
    'Medicine',
    'Physics and Astronomy',
    'Politics',
    'Public & Global Health',
    'Social and Behavioral Sciences',
    'Statistics',
    'Theology',
    'Other'
  ];